import { BookmarkEntity, ResponseValueObject } from '@gishub/domain';
import { axiosClient } from '../http/axios-client';
import { IBookmarkDatasource } from './i-bookmark-datasource';

export class ApiBookmarkDatasource implements IBookmarkDatasource {
  private readonly endpoint = '/bookmarks';

  // id, hash, log y createdAt los genera o administra el servidor; solo se envía lo editable
  private serialize(entity: BookmarkEntity): Partial<BookmarkEntity> {
    return {
      name: entity.name,
      bbox: entity.bbox,
      spatialReference: entity.spatialReference,
      layers: entity.layers,
      baseMap: entity.baseMap,
    };
  }

  async getAll(username: string): Promise<ResponseValueObject<BookmarkEntity[]>> {
    const response = await axiosClient.get<ResponseValueObject<BookmarkEntity[]>>(
      `${this.endpoint}`,
    );
    return response.data;
  }

  async getById(id: string | number): Promise<ResponseValueObject<BookmarkEntity>> {
    const response = await axiosClient.get<ResponseValueObject<BookmarkEntity>>(
      `${this.endpoint}/${id}`,
    );
    return response.data;
  }

  async create(entity: BookmarkEntity): Promise<ResponseValueObject<BookmarkEntity>> {
    const response = await axiosClient.post<ResponseValueObject<BookmarkEntity>>(
      `${this.endpoint}`,
      this.serialize(entity),
    );
    return response.data;
  }

  async update(entity: BookmarkEntity): Promise<ResponseValueObject<BookmarkEntity>> {
    const response = await axiosClient.put<ResponseValueObject<BookmarkEntity>>(
      `${this.endpoint}/${entity.id}`,
      this.serialize(entity),
    );
    return response.data;
  }

  async delete(entity: BookmarkEntity): Promise<ResponseValueObject<boolean>> {
    const response = await axiosClient.delete<ResponseValueObject<boolean>>(
      `${this.endpoint}/${entity.id}`,
    );
    return response.data;
  }
}
